<template>
    <TopNavbar
        :app-name="getAppName"
        :role="user?.role"
        :isProd="isProd"
    />
    <main class="container-fluid pt-3">
        <top-alert v-if="localFlash" :flash="flash" @close="onCloseAlert"/>
        <slot/>
    </main>
</template>

<script >
import TopNavbar from "../components/Widget/TopNavbar.vue";
import TopAlert from "../components/Widget/TopAlert.vue";

export default {
    name: 'MerchantLayout',
    props: {
        app: Object,
        user: Object,
        flash: Object|null,
        isProd: Boolean,
    },
    data() {
        return {
            localFlash: this.flash,
        }
    },
    watch: {
        'flash': function(newVal, oldVal) {
            this.localFlash = newVal;
        }
    },
    computed: {
        getAppName() {
            return this.app.name;
        }
    },
    methods: {
        onCloseAlert() {
            this.localFlash = null
        }
    },
    components: {
        TopNavbar,
        TopAlert,
    }
}
</script>

<style scoped>

</style>
